import React, { useState, useEffect, useContext, useRef } from "react";

import { store } from "../../context/store";

import { useHistory } from "react-router-dom";

import Header from "../../components/Header";

import LeftMenu from "../../components/LeftMenu";

import AssetSearchPanel from "./components/AssetSearchPanel";

import BuildingNavigator from "./components/BuildingNavigator";

import ScreenCapture from "./components/ScreenCapture";

import SlidingDrawer from "./components/SlidingDrawer";

import AssetDetails from "./components/AssetDetails";

import AssetMaintenanceDrawer from "./components/AssetMaintenanceDrawer";

import AssetDocumentsDrawer from "./components/AssetDocumentsDrawer";

import AssetInspectionDrawer from "./components/AssetInspectionDrawer";

import AssetInsightsDrawer from "./components/AssetInsightsDrawer";

import AssetAiDrawer from "./components/AssetAiDrawer";


export default function Giraffe()
{

    //--------------------------------------------------------
    // Context / Navigation
    //--------------------------------------------------------

    const globalState =
        useContext(store);

    const history =
        useHistory();

    const viewerRef =
        useRef(null);


    //--------------------------------------------------------
    // State
    //--------------------------------------------------------

    const [assetOpen, setAssetOpen] =
        useState(false);

    const [assetCode, setAssetCode] =
        useState(null);

    const [searchAsset, setSearchAsset] =
        useState(null);

    const [searchOpen, setSearchOpen] =
        useState(false);


    //--------------------------------------------------------
    // Asset Drawer State
    //--------------------------------------------------------

    const [documentsOpen, setDocumentsOpen] =
        useState(false);

    const [maintenanceOpen, setMaintenanceOpen] =
        useState(false);

    const [inspectionOpen, setInspectionOpen] =
        useState(false);

    const [insightsOpen, setInsightsOpen] =
        useState(false);

    const [assetAiOpen, setAssetAiOpen] =
        useState(false);


    //--------------------------------------------------------
    // Giraffe Hotspot Listener
    //--------------------------------------------------------

    useEffect(function ()
    {

        const handleMessage = (event) =>
        {

            // Always validate source / type before acting
            // on a postMessage.

            const tourFrame =
                viewerRef.current;


            if (!tourFrame)
                return;


            if (event.source !== tourFrame.contentWindow)
                return;


            if (event.data?.type !== "g360:info-hotspot-click")
                return;


            const
            {
                hotspotId,
                sceneKey,
                content
            } = event.data;


            openAssetDrawer(
                hotspotId);

        };


        window.addEventListener(
            "message",
            handleMessage
        );


        return () =>
        {

            window.removeEventListener(
                "message",
                handleMessage
            );

        };

    }, []);


    //--------------------------------------------------------
    // Open Asset
    //--------------------------------------------------------

    const openAssetDrawer = (code) =>
    {

        //----------------------------------------------------
        // Close Previously Opened Child Drawers
        //----------------------------------------------------

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(false);


        //----------------------------------------------------
        // Set Selected Asset
        //----------------------------------------------------

        setAssetCode(
            code);


        //----------------------------------------------------
        // Open Main Asset Drawer
        //----------------------------------------------------

        setAssetOpen(
            true);

    };


    //--------------------------------------------------------
    // Close Asset Drawer Stack
    //--------------------------------------------------------

    const closeAssetDrawers = () =>
    {

        setInspectionOpen(false);

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInsightsOpen(false);

        setAssetAiOpen(false);

        setAssetOpen(false);

    };


    //--------------------------------------------------------
    // Open AI Drawer
    //--------------------------------------------------------

    const openAssetAiDrawer = () =>
    {

        //----------------------------------------------------
        // Close Other Child Drawers
        //----------------------------------------------------

        setDocumentsOpen(false);

        setMaintenanceOpen(false);

        setInspectionOpen(false);

        setInsightsOpen(false);


        //----------------------------------------------------
        // Open AI
        //----------------------------------------------------

        setAssetAiOpen(
            true);

    };


    //--------------------------------------------------------
    // Styles
    //--------------------------------------------------------

    const pageContainer =
    {
        position:
            "relative",

        minHeight:
            "100vh",

        overflowX:
            "hidden",

        overflowY:
            "auto"
    };


    const pageBackground =
    {
        position:
            "fixed",

        top:
            0,

        left:
            0,

        width:
            "100vw",

        height:
            "100vh",

        backgroundColor:
            "white",

        zIndex:
            0,

        pointerEvents:
            "none"
    };


    const thisContainer =
    {
        display:
            "flex",

        flexDirection:
            "column",

        width:
            "100%",

        marginTop:
            "50px",

        minHeight:
            "100vh",

        position:
            "relative",

        zIndex:
            1
    };


    const mainContent =
    {
        display:
            "flex",

        position:
            "fixed",

        left:
            "60px",

        top:
            "0px",

        right:
            "0px",

        bottom:
            "0px"
    };


    const thisframe =
    {
        width:
            "100%",

        height:
            "100%"
    };


    //--------------------------------------------------------
    // Render
    //--------------------------------------------------------

    return (

        <div style={pageContainer}>


            {/*========================================================
              Background
            ========================================================*/}

            <div style={pageBackground} />


            {/*========================================================
              Main Page
            ========================================================*/}

            <div style={thisContainer}>

                <Header
                    transitionHide={true}
                />

                <LeftMenu />


                {/*====================================================
                  Giraffe Viewer
                ====================================================*/}

                <div style={mainContent}>

                    <iframe
                        ref={viewerRef}
                        style={thisframe}
                        src="https://tour.giraffe360.com/49c74ed43a75417c96cf6a2684fac357"
                        frameBorder="0"
                        title="Giraffe 360 Viewer"
                    />

                </div>

            </div>


            {/*========================================================
              Asset Search
            ========================================================*/}

            <AssetSearchPanel

                open={searchOpen}

                setOpen={setSearchOpen}

                onSelect={(asset) =>
                {

                    setSearchAsset(
                        asset);

                }}

            />


            {/*========================================================
              Asset Details Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={assetOpen}

                width={500}

                offset={0}

                zIndex={9999999}

                title="Asset Details"

                onClose={closeAssetDrawers}

            >

                <AssetDetails

                    assetCode={assetCode}

                    demoScenario="FCU"

                    onDocuments={() =>
                    {

                        setMaintenanceOpen(false);

                        setInspectionOpen(false);

                        setInsightsOpen(false);

                        setAssetAiOpen(false);

                        setDocumentsOpen(true);

                    }}

                    onMaintenance={() =>
                    {

                        setDocumentsOpen(false);

                        setInspectionOpen(false);

                        setInsightsOpen(false);

                        setAssetAiOpen(false);

                        setMaintenanceOpen(true);

                    }}

                    onInsights={() =>
                    {

                        setDocumentsOpen(false);

                        setMaintenanceOpen(false);

                        setInspectionOpen(false);

                        setAssetAiOpen(false);

                        setInsightsOpen(true);

                    }}

                    onAi={
                        openAssetAiDrawer
                    }

                />

            </SlidingDrawer>


            {/*========================================================
              AI Asset Intelligence Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={assetAiOpen}

                width={650}

                offset={500}

                zIndex={9999998}

                title="AI Asset Intelligence"

                onClose={() =>
                    setAssetAiOpen(false)
                }

            >

                <AssetAiDrawer

                    assetType="Fan Coil Unit"

                    manufacturer="Daikin"

                    model="FWE06CT"

                />

            </SlidingDrawer>


            {/*========================================================
              Documents Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={documentsOpen}

                width={900}

                offset={500}

                zIndex={9999998}

                title="Documents"

                onClose={() =>
                    setDocumentsOpen(false)
                }

            >

                <AssetDocumentsDrawer
                    assetCode={assetCode}
                />

            </SlidingDrawer>


            {/*========================================================
              Maintenance Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={maintenanceOpen}

                width={380}

                offset={500}

                zIndex={9999998}

                title="Maintenance"

                onClose={() =>
                    setMaintenanceOpen(false)
                }

            >

                <AssetMaintenanceDrawer

                    assetCode={assetCode}

                    onSelectInspection={() =>
                        setInspectionOpen(true)
                    }

                />

            </SlidingDrawer>


            {/*========================================================
              Inspection Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={inspectionOpen}

                width={420}

                offset={880}

                zIndex={9999997}

                title="Inspection"

                onClose={() =>
                    setInspectionOpen(false)
                }

            >

                <AssetInspectionDrawer
                    assetCode={assetCode}
                />

            </SlidingDrawer>


            {/*========================================================
              AI Insights Drawer
            ========================================================*/}

            <SlidingDrawer

                visible={insightsOpen}

                width={380}

                offset={500}

                zIndex={9999998}

                title="AI Insights"

                onClose={() =>
                    setInsightsOpen(false)
                }

            >

                <AssetInsightsDrawer
                    assetCode={assetCode}
                />

            </SlidingDrawer>


            {/*========================================================
              Building Navigator
            ========================================================*/}

            <BuildingNavigator />


            {/*========================================================
              Screen Capture
            ========================================================*/}

            <div
                style={{
                    position:
                        "fixed",

                    top:
                        "50px",

                    left:
                        "50px",

                    zIndex:
                        9999
                }}
            >

                <ScreenCapture />

            </div>


        </div>

    );

}